
const digest = '8ba4f6b2795db450f2d5183df93806e02ef360104bbf50d5a4f28a8cd70957e0';
const classes = {"wrapper":"_wrapper_5xawk_1","border":"_border_5xawk_4","content":"_content_5xawk_13","header":"_header_5xawk_18","openEntryName":"_openEntryName_5xawk_25","itemInfo":"_itemInfo_5xawk_36","controls":"_controls_5xawk_41"};
const css = `._wrapper_5xawk_1 {
  background: #fff;
}
._wrapper_5xawk_1 ._border_5xawk_4 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_5xawk_1 ._border_5xawk_4:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._content_5xawk_13 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._content_5xawk_13 ._header_5xawk_18 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px;
  padding: 12px 0 0 0;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._content_5xawk_13 ._header_5xawk_18 ._openEntryName_5xawk_25 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._content_5xawk_13 ._header_5xawk_18 ._openEntryName_5xawk_25 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._content_5xawk_13 ._itemInfo_5xawk_36 {
  display: flex;
  flex-direction: column;
  margin: 12px;
}
._wrapper_5xawk_1 ._border_5xawk_4 ._controls_5xawk_41 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  